import { createSelector } from 'reselect';

import getPopupState from '~/src/packages/bp42/selectors/getPopupState';
import isInitialized from '~/src/packages/bp42/selectors/isInitialized';

const selectDataForMainPopup = createSelector([
    isInitialized,
    getPopupState,
], (initialized, isPopupOpen) => ({
    initialized,
    isPopupOpen,
}));

export default selectDataForMainPopup;
